import { forwardRef } from 'react';
import Disclaimer from './Disclaimer';
import { formatCurrency } from '../utils/formatCurrency';
import { useStore } from '../store/useStore';
import LogoInline from './LogoInline';

const PrintOut = forwardRef<HTMLDivElement>((props, ref) => {
	const store = useStore((state: any) => state);
	const today = new Date();
	return (
		<div ref={ref} className="kootenai-print-out-wrap">
			<div className="kootenai-print-out-header">
				<div className="kootenai-print-out-header-left">
					<LogoInline />

					<h2 className="kootenai-print-out-title">
						Estimated Sellers Net Proceeds
					</h2>

					<span className="kootenai-print-out-date">{`Generated on ${
						today.getMonth() + 1
					}/${today.getDate()}/${today.getFullYear()}`}</span>
				</div>

				<div className="kootenai-print-out-header-right">
					<div className="kootenai-print-out-header-text">
						502 North 2nd Street
						<br />
						Yakima, WA, 98901
						<br />
						P. (509) 248-4442
					</div>
				</div>
			</div>

			<table className={'kootenai-print-out'}>
				<tbody>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							First Name
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{store.firstName}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Last Name
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{store.lastName}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Email Address
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{store.email}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							House Address
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{store.homeAddress}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-3`}>
						<td className={`kootenai-col kootenai-field kootenai-type-SECTION`}>
							<h2>Seller Information</h2>
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-3`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Sales Price
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.salesPrice.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-3`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Loan Payoff
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.loanPayoffs.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-3`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Real Estate Commission
						</td>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-PERCENT`}
						>
							{store.realEstateCommissionPercent}%
						</td>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.realEstateCommission.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-1`}>
						<td className={`kootenai-col kootenai-field kootenai-type-SECTION`}>
							<h2>Title Insurance</h2>
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Title Insurance(Owner's policy)
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type-`}
						>
							{formatCurrency(store.titleInsurance.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td className={`kootenai-col kootenai-field kootenai-type-SECTION`}>
							<h2>Escrow Services</h2>
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Escrow Fee
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.escrowFee.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td className={`kootenai-col kootenai-field kootenai-type-SECTION`}>
							<h2>Miscellaneous</h2>
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Seller's Contribution
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.sellersContributions.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							{store.other1Label}
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.other1.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							{store.other2Label}
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.other2.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td className={`kootenai-col kootenai-field kootenai-type-SECTION`}>
							<h2>Totals</h2>
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Estimated Total Costs
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.estimatedTotalCosts)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Total Loan Payoffs
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.loanPayoffs.raw)}
						</td>
					</tr>
					<tr className={`kootenai-row kootenai-row-2`}>
						<td
							colSpan={1}
							className={`kootenai-col kootenai-field kootenai-type-LABEL`}
						>
							Estimated Net Proceeds
						</td>
						<td
							colSpan={2}
							className={`kootenai-col kootenai-field kootenai-type`}
						>
							{formatCurrency(store.estimatedNetProceeds)}
						</td>
					</tr>
				</tbody>
			</table>
			<Disclaimer />
		</div>
	);
});

export default PrintOut;
